import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export enum DeepResearchToolType {
  // Supervisor-level tools
  ResearchSubAgent = 'ResearchSubAgent',
  Think = 'Think',
  CompleteAnswer = 'CompleteAnswer',
  PublicDataSubAgent = 'PublicDataSubAgent',

  // Sub-agent tools
  SearchTool = 'SearchTool',
  GetWarehouseOverviewTool = 'GetWarehouseOverviewTool',
  SearchNotebookEntries = 'SearchNotebookEntries',
  SearchSequencesTool = 'SearchSequencesTool',
  QueryWarehouseTool = 'QueryWarehouseTool',
  ReadBenchlingDocumentTool = 'ReadBenchlingDocument',
  AttachmentTool = 'AttachmentTool',
  IdsToModelsTool = 'IdsToModelsTool',
}

export const TOOL_DESCRIPTIONS = {
  [DeepResearchToolType.ResearchSubAgent]: 'Researching',
  [DeepResearchToolType.Think]: 'Thinking',
  [DeepResearchToolType.CompleteAnswer]: 'Writing report',
  [DeepResearchToolType.PublicDataSubAgent]: 'Searching public data',
  [DeepResearchToolType.SearchTool]: 'Searching benchling',
  [DeepResearchToolType.GetWarehouseOverviewTool]: 'Getting warehouse overview',
  [DeepResearchToolType.SearchNotebookEntries]: 'Searching notebook entries',
  [DeepResearchToolType.SearchSequencesTool]: 'Searching sequences',
  [DeepResearchToolType.QueryWarehouseTool]: 'Querying warehouse',
  [DeepResearchToolType.ReadBenchlingDocumentTool]: 'Reading notebook',
  [DeepResearchToolType.AttachmentTool]: 'Reading attachment',
  [DeepResearchToolType.IdsToModelsTool]: 'Looking things up',
};

export const TOOL_ICONS: Record<DeepResearchToolType, BenchlingIconName> = {
  [DeepResearchToolType.ResearchSubAgent]: 'magic-wand',
  [DeepResearchToolType.Think]: 'lightbulb',
  [DeepResearchToolType.CompleteAnswer]: 'file',
  [DeepResearchToolType.PublicDataSubAgent]: 'link',
  [DeepResearchToolType.SearchTool]: 'magnifying-glass',
  [DeepResearchToolType.GetWarehouseOverviewTool]: 'warehouse-full',
  [DeepResearchToolType.SearchNotebookEntries]: 'magnifying-glass',
  [DeepResearchToolType.SearchSequencesTool]: 'magnifying-glass',
  [DeepResearchToolType.QueryWarehouseTool]: 'warehouse-full',
  [DeepResearchToolType.ReadBenchlingDocumentTool]: 'file',
  [DeepResearchToolType.AttachmentTool]: 'file',
  [DeepResearchToolType.IdsToModelsTool]: 'magnifying-glass',
};

export enum ToolCallStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
}

export interface BaseProgressToolCall {
  tool: DeepResearchToolType;
  toolId: string;
  createdAt: Date;
  status: ToolCallStatus;
  chipName: string;
  responseText?: string;
}
export interface SearchToolCall extends BaseProgressToolCall {
  tool: DeepResearchToolType.SearchTool;
  query: string;
  objectTypes: Array<string>;
}

export interface GetWarehouseOverviewToolCall extends BaseProgressToolCall {
  tool: DeepResearchToolType.GetWarehouseOverviewTool;
}

export interface QueryWarehouseToolCall extends BaseProgressToolCall {
  tool: DeepResearchToolType.QueryWarehouseTool;
  query: string;
}

export interface ReadBenchlingDocumentToolCall extends BaseProgressToolCall {
  tool: DeepResearchToolType.ReadBenchlingDocumentTool;
  notebookId: string;
}

export interface AttachmentToolCall extends BaseProgressToolCall {
  tool: DeepResearchToolType.AttachmentTool;
  attachmentId: string;
}

export interface PublicDataSubAgentToolCall extends BaseProgressToolCall {
  tool: DeepResearchToolType.PublicDataSubAgent;
  query: string;
}

export interface SearchNotebookEntriesToolCall extends BaseProgressToolCall {
  tool: DeepResearchToolType.SearchNotebookEntries;
  query: string;
}

export interface SearchSequencesToolCall extends BaseProgressToolCall {
  tool: DeepResearchToolType.SearchSequencesTool;
  query: string;
}

export interface IdsToModelsToolCall extends BaseProgressToolCall {
  tool: DeepResearchToolType.IdsToModelsTool;
  objectIds: Array<string>;
  includeRelevantItems: boolean;
}

export type ProgressToolCall =
  | SearchToolCall
  | GetWarehouseOverviewToolCall
  | QueryWarehouseToolCall
  | ReadBenchlingDocumentToolCall
  | SearchNotebookEntriesToolCall
  | SearchSequencesToolCall
  | AttachmentToolCall
  | PublicDataSubAgentToolCall
  | IdsToModelsToolCall
  | BaseProgressToolCall; // We include base for any unsupported tool calls
